// extracted by mini-css-extract-plugin
export default {"no-loads-advice":"LoadsTable_no-loads-advice__4yAIn","loads-table":"LoadsTable_loads-table__IC62i","loads-table-col-name":"LoadsTable_loads-table-col-name__DW+8i"};